import React, { useEffect, useRef, useState } from "react";
import * as S from "../../../Common/styles";

export const SLIITAListScienceSubjects = (props) => {
    const textboxRef = useRef(null);

    useEffect(() => {
        
        if (props.selected.includes("Other (please specify if your subject is not listed)")) {
        // Focus on the textbox when the "Other" option is selected
        textboxRef.current.focus();
        } else {
          textboxRef.current && (textboxRef.current.value = '');  
        }
    }, [props.selected]);
    return (
        <S.Checkbox>
            <label>
                <input name={props.name} className="form-check-input" type="checkbox" onChange={(e) => props.onChange(e)} value="Physics" checked={props.selected.includes("Physics")}/>
                Physics
            </label>
            <label>
                <input name={props.name} className="form-check-input" type="checkbox" onChange={(e) => props.onChange(e)} value="Chemistry" checked={props.selected.includes("Chemistry")}/>
                Chemistry
            </label>
            <label>
                <input name={props.name} className="form-check-input" type="checkbox" onChange={(e) => props.onChange(e)} value="Mathematics" checked={props.selected.includes("Mathematics")}/>
                Mathematics
            </label>
            <label>
                <input name={props.name} className="form-check-input" type="checkbox" onChange={(e) => props.onChange(e)} value="Applied Mathematics or Pure Mathematics or Combined Mathematics or Further Mathematics" checked={props.selected.includes("Applied Mathematics or Pure Mathematics or Combined Mathematics or Further Mathematics")}/>
                Applied Mathematics or Pure Mathematics or Combined Mathematics or Further Mathematics
            </label>
            <label>
                <input name={props.name} className="form-check-input" type="checkbox" onChange={(e) => props.onChange(e)} value="Other (please specify if your subject is not listed)" checked={props.selected.includes("Other (please specify if your subject is not listed)")}/>
                Other (please specify if your subject is not listed)
            </label>
            
            <S.Textbox ref={textboxRef} name="sliitALEAScienceSubjectOther" value={props.sliitALEAScienceSubjectOther} disabled={!props.selected.includes("Other (please specify if your subject is not listed)")} onChange={(e) => props.onChange(e)} />            
        </S.Checkbox>
    );    
}